import Moment from "moment";
import "moment-timezone";
import $ from "jquery";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { API_URL } from "../utils/apiRoutes";
import moment from "moment";
import axios from "axios";
import { errorToastMessage, successToastMessage } from "./toastMessage";
import { apiCall } from "./axiosService";
import { apiResponse } from "./apiResponse";
import { toast } from "react-toastify";
import { month } from "./constant";
import html2canvas from "html2canvas";

import EMA_loginLogo from "../Assets/Images/LogIn/newlogo.svg";
import EMA_RevEvolve from "../Assets/Images/LogIn/RevEvolve60.png";
import EMA_logo from "../Assets/Images/Header/header-logo.png";

import revnomix_loginLogo from "../Assets/Images/LogIn/revnomix1.png";
import revnomix_RevEvolve from "../Assets/Images/LogIn/revnomix2.png";
import sideArrow from "../Assets/Images/Home-dashboard/sideArrow.svg";
import dbaccounting from "../Assets/Images/Home-dashboard/dbaccounting.svg";

import mho_loginLogo from "../Assets/Images/LogIn/MHO1.png";
import mho_RevEvolve from "../Assets/Images/LogIn/MHO2.png";

import rategain_loginLogo from "../Assets/Images/LogIn/rategain1.png";
import rategain_RevEvolve from "../Assets/Images/LogIn/rategain2.png";

import NextGen_loginLogo from "../Assets/Images/LogIn/NextGen01.jpg";
import NextGen_RevEvolve from "../Assets/Images/LogIn/NextGen02.jpg";

import EnvisionHospitality_loginLogo from "../Assets/Images/LogIn/EnvisionHospitality1.jpg";
import EnvisionHospitality_RevEvolve from "../Assets/Images/LogIn/EnvisionHospitality2.jpg";

const cryptoKey = "SqT_cL@SsRoOm_S@T!Sh_393987";

export const commonService = {
    setItem,
    getItem,
    getHeaders,
    getHeadersFromData,
    getLoginUserData,
    getDateInFormat,
    getDateInFormatWithDayName,
    getDateTimeInFormat,
    getFileType,
    getDateTimeInDBFormat,
    getDateInDBFormat,
    getDateInDateMonthFormat,
    getTimeInFormat,
    CreateColor,
    getColorByCategory,
    getDateInMonthYearFormat,
    groupArrayOfObjects,
    getLoginRoleData,
    SendPushNotification,
    ServerSideAjaxCall,
    ConvertDateInUTC,
    getFutureYearForDropDown,
    getPastYearForDropDown,
    checkDateIsValid,
    checkTermIsAvailable,
    checkPropertyIsAvailable,
    checkUserRole,
    checkUserPropertyRole,
    getDatesInRange,
    GenerateGUID,
    fnExportInCSV,
    fnExportSnapShotInCSV,
    getAllDatesInMonth,
    setBackColorPerByTDValue,
    setBackColorPerByTDValueInPercentage,
    datesBetweenTwoDate,
    getAmountInCompactFormat,
    getAmountInFormat,
    getDateForNode,
    getDateBetweenTwoDates,
    fnExportChartInCSV,
    fnSendWidgetMail,
    fnSendtSnapShotMail,
    ShortArray,
    FloatValueToFixed,
    convertDateInTimezone,
    getLastYearDate,
    getDateBetweenTwoDatesForHiglightRateIq,
    widgetWiseExportExcel,
    generateRandomColor,
    getWeekStartAndEndDate,
    getAllDatesInMonthForAdrChart,
    formateAmount,
    getItemWithoutCrypto,
    setItemWithoutCrypto,
    formateRoom,
    getMonthNamesUntil,
    fnArchive,
    convertsnapshotToImg,
    stringToHtmlTableExport,
    fnSetMainAndSubDomain,
    ClearLocalStorage,
    LogOutToUser,
    GetLogo,
    GetRevenueModuleHTML,
    GetLogoHeaderTitle,
    getNodeHeaders,
    getRMAPIHeaders,
    getNodeHeadersFromData,
    fnGenerateSnapshotHTML,
    getConvertDateInTimeZone,
    GrowthFormula,
    SummationFormula,
    setBackColorWithCompareSameTDIndex,
    FindPercentageOfValue,
    FindPercentageOfValueMaxUpTo100,
    GrowthDiifValue,
    ForecastTypeDisplayLable,
    getDateInRatemetricsHorizonRangeFormat,
    timeAgo,
    DayDiffOfTowDate,
    checkUserRoleAllOption,
    setAttrDataOfFromTableHeaders,
    generateGlobalClickTrackerID,
    getCurrentModuleName,
    truncateName
};

function truncateName(filename, maxLength = 10) {
    if (filename && filename !== "" && filename !== null && filename !== undefined) {
        const [baseName, extension] = filename?.split(".");
        const truncatedBaseName =
            baseName.length > maxLength ? baseName.substring(0, maxLength) + "..." : baseName;

        return truncatedBaseName ? truncatedBaseName : "" + "." + extension ? extension : "";
    }
};

function getDateForNode(date) {
    let newDate = new Date(date);

    return moment(newDate).format("YYYY-MM-DD");
}

function datesBetweenTwoDate(startDate, endDate) {
    var dateObj = {};
    var currentDate = startDate;
    while (new Date(currentDate).getTime() <= new Date(endDate).getTime()) {
        dateObj[moment(currentDate).format("YYYY-MM-DD")] = {};
        currentDate = new Date(currentDate).setDate(
            new Date(currentDate).getDate() + 1
        );
    }
    return dateObj;
}

function getAllDatesInMonth(year, month) {
    let startDate = convertDateInTimezone(new Date(year, month, 1)); // month is 0-indexed
    let endDate = convertDateInTimezone(new Date(year, month + 1, 1));

    let dates = [];
    while (startDate < endDate) {
        dates.push(new Date(startDate).getDate()); // clone the date object
        startDate.setDate(startDate.getDate() + 1);
    }

    return dates;
}

function getAllDatesInMonthForAdrChart(startDate, endDate) {
    const date = new Date(startDate.getTime());

    let dates = [];

    while (date <= endDate) {
        dates = [...dates, getDateInFormat(convertDateInTimezone(date))];
        date.setDate(date.getDate() + 1);
    }

    return dates;
}

function GenerateGUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

function getDatesInRange(startDate, endDate) {
    const date = new Date(startDate.getTime());

    let dates = {};

    while (date <= endDate) {
        dates = {
            ...dates,
            [getDateInFormat(new Date(date))]: {
                data: [{ new: "newRow" }],
                totalRevenue: 0,
                totalRoomSold: 0,
            },
        };
        date.setDate(date.getDate() + 1);
    }

    return dates;
}

function getDateBetweenTwoDates(startDate, endDate) {
    const date = new Date(startDate.getTime());

    let dates = [];

    while (date <= endDate) {
        dates = [...dates, getDateInFormat(convertDateInTimezone(date))];
        date.setDate(date.getDate() + 1);
    }

    return dates;
}

function getDateBetweenTwoDatesForHiglightRateIq(startDate, endDate) {
    const date = new Date(startDate.getTime());

    let dates = [];

    while (date < endDate) {
        dates = [...dates, getDateInFormat(convertDateInTimezone(date))];
        date.setDate(date.getDate() + 1);
    }

    return dates;
}

function checkUserRole(moduleName, pageName, key) {
    const rights = commonService.getItem("userRights");
    const userRights = rights ? JSON.parse(rights) : [];
    let access = false;
    let filter = userRights?.userrole?.filter((r) => r?.modulename.toUpperCase() === moduleName.toUpperCase() && r?.pagename.toUpperCase() === pageName.toUpperCase());
    if (filter && filter?.length > 0) {
        if (filter?.[0]?.[key] === 1) {
            access = true;
        }
    }
    return access;
}


function checkUserRoleAllOption(moduleName, pageName) {
    const rights = commonService.getItem("userRights");
    const userRights = rights ? JSON.parse(rights) : [];

    let access = {
        iscreate: false,
        isdelete: false,
        isenable: false,
        isupdate: false,
        isview: false
    };
    let filter = userRights?.userrole.filter((r) => r.modulename.toUpperCase() === moduleName.toUpperCase() && r.pagename.toUpperCase() === pageName.toUpperCase());
    if (filter && filter.length > 0) {
        if (filter[0]?.iscreate === 1) {
            access.iscreate = true;
        }

        if (filter[0]?.isdelete === 1) {
            access.isdelete = true;
        }

        if (filter[0]?.isenable === 1) {
            access.isenable = true;
        }

        if (filter[0]?.isupdate === 1) {
            access.isupdate = true;
        }

        if (filter[0]?.isview === 1) {
            access.isview = true;
        }

    }
    return access;
}


function checkUserPropertyRole(propertyId, moduleName, pageName, key) {
    const rights = commonService.getItem("userRights");
    const userRights = rights ? JSON.parse(rights) : [];
    let access = false;
    for (let i = 0; i < userRights?.userpropertyrole?.length; i++) {
        if (
            userRights?.userpropertyrole?.[i]?.propertyid === propertyId &&
            userRights?.userpropertyrole?.[i]?.modulename?.toUpperCase() === moduleName?.toUpperCase() &&
            userRights?.userpropertyrole?.[i]?.pagename?.toUpperCase() === pageName?.toUpperCase() &&
            userRights?.userpropertyrole?.[i]?.[key] === 1
        ) {
            access = true;
        }
    }
    return access;
}

function checkTermIsAvailable(termList, term) {
    let termName = "";
    termList?.map((item) => {
        if (item?.term === term) {
            termName = item?.term;
        }
    });
    return termName;
}

function checkPropertyIsAvailable(propertyList, propertyId) {
    let propertyIdDetail = "";
    propertyList?.map((item) => {
        if (item?.propertyid == propertyId) {
            propertyIdDetail = item?.propertyid;
        }
    });
    return propertyIdDetail;
}

function ConvertDateInUTC(date) {
    return new Date(new Date(date) + " UTC");
}

function checkDateIsValid(date) {
    let dateObj = Date.parse(date);
    let isValidDate = true;
    if (isNaN(dateObj)) {
        isValidDate = false;
    }
    return isValidDate;
}

function getFutureYearForDropDown(year) {
    const currentYear = new Date().getFullYear();
    let years = [];

    for (let i = 1; i <= year; i++) {
        years.push(currentYear + i);
    }

    return years;
}

function getPastYearForDropDown(year) {
    const currentYear = new Date().getFullYear();
    let years = [];

    for (let i = 1; i <= year; i++) {
        years.push(currentYear - i);
    }

    return years;
}

function setItem(key, strString) {
    let CryptoJS = require("crypto-js");
    localStorage.setItem(key, CryptoJS.AES.encrypt(strString, cryptoKey));
}

function getItem(key) {
    let CryptoJS = require("crypto-js");
    let dataValues = localStorage.getItem(key) || "";
    let dataStr = "";
    if (dataValues !== "") {
        var bytes = CryptoJS.AES.decrypt(dataValues, cryptoKey);
        dataStr = bytes.toString(CryptoJS.enc.Utf8);
    }
    //This Code Comment By Satish Thummar On 2026-06-22 For MarketPlace
    if (dataStr === "") {
        if (key === "SD") {
            dataStr = window.location.origin;
        }
        if (key === "MD") {
            dataStr = window.location.origin;
        }
        if (key === "userRights") {
            LogOutToUser();
        }
    }
    //This Code Comment By Satish Thummar On 2026-06-22 For MarketPlace
    return dataStr;
}

function getItemWithoutCrypto(key) {
    let dataStr = localStorage.getItem(key) || "";
    return dataStr;
}

function setItemWithoutCrypto(key, strString) {
    localStorage.setItem(key, strString);
}

function getHeaders() {
    return {
        "Content-Type": "application/json",
        accept: "*/*",
        Authorization: "Bearer " + getItem("token"),
    };
}

function SendPushNotification(
    title,
    details,
    associationid,
    associationtype,
    SendToUserIDs
) {
    let userData = getLoginUserData();
    if (
        userData !== null &&
        userData.userid !== 0 &&
        userData.tlog !== null &&
        userData.tlog !== ""
    ) {
        const connect = new HubConnectionBuilder()
            .withUrl(API_URL.BASE_API_URL.LogAndMessage, { withCredentials: false })
            .withAutomaticReconnect()
            .build();
        connect
            .start()
            .then(() => {
                connect.send("sendnotification", {
                    notificationbyid: userData.userid,
                    notificationtoids: SendToUserIDs,
                    title: title,
                    details: details,
                    associationid: associationid,
                    associationtype: associationtype,
                    notificationbyname: userData.displayname,
                    tlog: userData.tlog,
                });
            })
            .catch((error) => { });
    }
}

function getHeadersFromData() {
    return {
        "Content-Type": "multipart/form-data",
        accept: "*/*",
        Authorization: "Bearer " + getItem("token"),
    };
}

function getNodeHeaders() {
    return {
        "Content-Type": "application/json",
        accept: "*/*",
        Authorization: "Bearer " + getItem("ntoken"),
    };
}

function getRMAPIHeaders() {
    return {
        "Content-Type": "application/json",
        accept: "*/*",
        "x-api-key": "c7bf79e2-28e1-4372-x6q8-1e42cbb3d479",
    };
}

function getNodeHeadersFromData() {
    return {
        "Content-Type": "multipart/form-data",
        accept: "*/*",
        Authorization: "Bearer " + getItem("ntoken"),
    };
}

function getLoginUserData() {
    var data = {
        userid: "0",
        employeeid: "0",
        username: "",
        email: "",
        mobileno: "",
        displayname: "",
        profilepic: null,
        timezone: null,
        firstname: "",
        lastname: "",
        clientid: "0",
        tlog: "",
        issuperadmin: "0",
        userpreferences: {
            Heatmap: {
                DefaultDataView: "Total OTB",
                // "7 Day Pickup From": false,
                // "Total OTB": true,
            },
        },
    };
    let dataStr = getItem("userDetail");
    if (dataStr !== "") {
        data = JSON.parse(dataStr);
        if (data) {
            if (!data.hasOwnProperty('issuperadmin')) {
                data.issuperadmin = 0;
            }
        }
    }
    //This Code Comment By Satish Thummar On 2026-06-22 For MarketPlace
    // else {
    //     commonService.LogOutToUser()
    // }
    //This Code Comment By Satish Thummar On 2026-06-22 For MarketPlace

    return data;
}

function getLoginRoleData(PageName, ActionType) {
    let IsValidAction = false;
    var roledata = [];
    let roledataStr = getItem("roledata");
    if (roledataStr !== "") {
        roledata = JSON.parse(roledataStr);
        for (let i = 0; i < roledata.length; i++) {
            if (roledata[i].RightName.toUpperCase() == PageName.toUpperCase()) {
                if (ActionType.toUpperCase() == "ISVIEW") {
                    return roledata[i].IsView;
                } else if (ActionType.toUpperCase() == "ISCREATE") {
                    return roledata[i].IsCreate;
                } else if (ActionType.toUpperCase() == "ISDELETE") {
                    return roledata[i].IsDelete;
                } else if (ActionType.toUpperCase() == "ISDOWNLOAD") {
                    return roledata[i].IsDownload;
                } else if (ActionType.toUpperCase() == "ISEDIT") {
                    return roledata[i].IsEdit;
                } else if (ActionType.toUpperCase() == "ISPRINT") {
                    return roledata[i].IsPrint;
                }
            }
        }
    }

    return IsValidAction;
}

function getDateInFormat(date) {
    if (!date) return "";
    const formattedDate = Moment(date);
    return formattedDate.isValid()
        ? formattedDate.format("L")
        : "";
}

function getDateInFormatWithDayName(date) {
    if (date !== null && date !== "" && date !== undefined)
        return Moment(date).format("ddd");
    else return "";
}

function getDateTimeInFormat(date) {
    if (date !== null && date !== "" && date !== undefined)
        return Moment(date).format("L h:mm a");
    else return "";
}

function getDateTimeInDBFormat(date) {
    if (date !== null && date !== "" && date !== undefined)
        return Moment(date).format("YYYY-MM-DD HH:mm:ss");
    else return "";
}

function getDateInDBFormat(date) {
    if (date !== null && date !== "" && date !== undefined)
        return Moment(date).format("YYYY-MM-DD");
    // return Moment(date).format("YYYY-MM-DD HH:mm:ss");
    else return "";
}

function getDateInRatemetricsHorizonRangeFormat(date) {
    if (date !== null && date !== "" && date !== undefined)
        return Moment(date).format("YYYY/MM/DD");
    // return Moment(date).format("YYYY-MM-DD HH:mm:ss");
    else return "";
}

function getDateInDateMonthFormat(date) {
    if (date !== null && date !== "" && date !== undefined)
        return Moment(date).format("DD MMM");
    else return "";
}

function getDateInMonthYearFormat(date) {
    if (date !== null && date !== "" && date !== undefined)
        return Moment(date).format("MMM YYYY");
    else return "";
}

function getTimeInFormat(date) {
    if (date !== null && date !== "" && date !== undefined)
        return Moment(date).format("h:mm a");
    else return "";
}

function getConvertDateInTimeZone(date, timezone, format) {

    if (format) {
    } else {
        format = "MM/DD/yyyy";
    }

    if (date !== null && date !== "" && date !== undefined) {

        const utcTime = moment.utc(date, "YYYY-MM-DD HH:mm:ss");
        const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (timezone) {

        }
        else {
            timezone = localTimezone;
        }
        const localTime = utcTime.tz(timezone);

        const formattedLocalTime = localTime?.format(format);

        return formattedLocalTime;
    }
}


function getAmountInCompactFormat(amount, isWithSymbol, currency) {
    if (!currency) {
        let findSelectedPropertyData = getItem("property");
        if (findSelectedPropertyData) {
            findSelectedPropertyData = JSON.parse(findSelectedPropertyData);
            if (findSelectedPropertyData) {
                currency = findSelectedPropertyData?.currency_term;
            }
        }
    }

    if (amount !== undefined && amount !== null && amount !== "") {
        amount = Math.round(parseFloat(amount));
        if (amount < 1000) {
            amount = amount;
        } else if (amount >= 1000 && amount < 1_000_000) {
            amount = (amount / 1000).toFixed(1) + "K";
        } else if (amount >= 1_000_000 && amount < 1_000_000_000) {
            amount = (amount / 1_000_000).toFixed(1) + "M";
        } else if (amount >= 1_000_000_000 && amount < 1_000_000_000_000) {
            amount = (amount / 1_000_000_000).toFixed(1) + "B";
        } else if (amount >= 1_000_000_000_000 && amount < 1_000_000_000_000_000) {
            amount = (amount / 1_000_000_000_000).toFixed(1) + "T";
        }
    } else {
        amount = 0;
    }

    if (isWithSymbol) {
        return `${currency ? currency : "$"}${amount.toString()}`;
    } else {
        return amount;
    }
}

function getAmountInFormat(amount) {
    var currency = "$";
    let findSelectedPropertyData = getItem("property");
    if (findSelectedPropertyData) {
        findSelectedPropertyData = JSON.parse(findSelectedPropertyData);
        if (findSelectedPropertyData) {
            currency = findSelectedPropertyData?.currency_term;
        }
    }

    if (amount !== undefined && amount !== null && amount !== "") {
        return currency + amount.toString();
    } else {
        return currency + "0";
    }
}

function getFileType(file) {
    let FileType = "FILE";
    if (file !== null && file !== undefined) {
        if (file.type !== null && file.type !== "" && file.type !== undefined) {
            if (file.type.toUpperCase().indexOf("IMAGE") >= 0) {
                FileType = "IMAGE";
            } else if (file.type.toUpperCase().indexOf("AUDIO") >= 0) {
                FileType = "AUDIO";
            } else if (file.type.toUpperCase().indexOf("VIDEO") >= 0) {
                FileType = "VIDEO";
            } else if (file.type.toUpperCase().indexOf("PDF") >= 0) {
                FileType = "PDF";
            }
        }
    }
    return FileType;
}


function getColorByCategory(name = "") {
    const PALETTE = ["#2980B9", "#27AE60", "#E67E22", "#8E44AD", "#E74C3C", "#16A085", "#F39C12", "#2C3E50", "#D35400", "#1ABC9C", "#34495E", "#9B59B6"];
    const str = String(name).trim().toLowerCase();

    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash |= 0;
    }

    const color = PALETTE[Math.abs(hash) % PALETTE.length];

    return {
        color,
        light: `${color}20`, // ~12% opacity (#RRGGBBAA)
    };
};

function CreateColor(str) {
    let BGRGB = "000000";
    let FRGB = "FFFFFF";
    if (str !== "") {
        str = str + "000000";
        let hash = hashCode(str);
        BGRGB = intToRGB(hash);
        FRGB = invertColor(BGRGB);
    }
    return { BGColor: BGRGB, FontColor: FRGB };
}

function hashCode(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
}

function intToRGB(i) {
    var c = (i & 0x00ffffff).toString(16).toUpperCase();
    return "#" + "000000".substring(0, 6 - c.length) + c;
}

function invertColor(hex) {
    if (hex.indexOf("#") === 0) {
        hex = hex.slice(1);
    }
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error("Invalid HEX color.");
    }

    var r = (255).toString(16),
        g = (255).toString(16),
        b = (255).toString(16);
    return "#" + padZero(r) + padZero(g) + padZero(b);
}

function padZero(str, len) {
    len = len || 2;
    var zeros = new Array(len).join("0");
    return (zeros + str).slice(-len);
}

function groupArrayOfObjects(list, key) {
    return list.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}

function ServerSideAjaxCall(url, data) {
    return {
        url: url,
        method: "POST",
        data: data,
        headers: {
            accept: "*/*",
            Authorization: "Bearer " + getItem("token"),
        },
        beforeSend: function (re) { },
        error: function () { },
        dataFilter: function (data) {
            var json = {
                recordsTotal: 0,
                recordsFiltered: 0,
                data: [],
            };

            data = JSON.parse(data);
            if (data.status_code === 1) {
                json = {
                    recordsTotal: data.data[0].totalrecords,
                    recordsFiltered: data.data[0].totalrecords,
                    data: data.data,
                };
            }

            return JSON.stringify(json);
        },
    };
}

function setAttrDataOfFromTableHeaders(tableId) {
    if (!tableId) {
        return;
    }

    const selector =
        typeof tableId === "string" && tableId.startsWith("#")
            ? tableId
            : `#${tableId}`;
    const $table = $(selector);

    if (!$table.length) {
        return;
    }

    let $headerRows = $table.find("thead tr");
    if (!$headerRows.length) {
        $headerRows = $table.find("tr").filter(function () {
            return $(this).children("th").length > 0;
        });
    }

    if (!$headerRows.length) {
        return;
    }

    const headerGrid = [];

    $headerRows.each(function (rowIndex) {
        if (!headerGrid[rowIndex]) {
            headerGrid[rowIndex] = [];
        }

        let colIndex = 0;
        while (headerGrid[rowIndex][colIndex]) {
            colIndex++;
        }

        $(this)
            .children("th,td")
            .each(function () {
                if ($(this).hasClass("d-none") || $(this).css("display") === "none") {
                    return;
                }

                while (headerGrid[rowIndex][colIndex]) {
                    colIndex++;
                }

                const colspan = parseInt($(this).attr("colspan"), 10) || 1;
                const rowspan = parseInt($(this).attr("rowspan"), 10) || 1;
                let headerTextSource = $(this).attr("data-export");

                if (!headerTextSource) {
                    const $headerClone = $(this).clone();
                    $headerClone
                        .find("span[style*='display:none'], span[style*='display: none'], span.d-none, span[hidden]")
                        .remove();
                    $headerClone
                        .find(".react-datepicker__aria-live")
                        .remove();

                    $headerClone.find("input, textarea, select, button").remove();
                    headerTextSource = $headerClone.text();
                }

                const text = (((headerTextSource || "") + "")
                    .replace(/\s+/g, " ")
                    .trim());

                for (let r = 0; r < rowspan; r++) {
                    if (!headerGrid[rowIndex + r]) {
                        headerGrid[rowIndex + r] = [];
                    }

                    for (let c = 0; c < colspan; c++) {
                        headerGrid[rowIndex + r][colIndex + c] = text;
                    }
                }

                colIndex += colspan;
            });
    });

    const maxCols = headerGrid.reduce((max, row) => Math.max(max, row ? row.length : 0), 0);
    const headersByColumn = [];

    for (let col = 0; col < maxCols; col++) {
        const parts = [];

        for (let row = 0; row < headerGrid.length; row++) {
            const headerText = headerGrid[row]?.[col];
            if (headerText && parts[parts.length - 1] !== headerText) {
                parts.push(headerText);
            }
        }

        headersByColumn[col] = parts.join(" |#| ");
    }

    $table.find("tbody tr").each(function () {
        let colIndex = 0;

        $(this)
            .children("td,th")
            .each(function () {
                if ($(this).hasClass("d-none") || $(this).css("display") === "none") {
                    return;
                }

                const colspan = parseInt($(this).attr("colspan"), 10) || 1;
                const headerParts = [];

                for (let c = 0; c < colspan; c++) {
                    const headerText = headersByColumn[colIndex + c];
                    if (headerText && !headerParts.includes(headerText)) {
                        headerParts.push(headerText);
                    }
                }

                if (this.tagName.toLowerCase() === "td") {
                    $(this).attr("attr-data-of", headerParts.join(" | "));
                }

                colIndex += colspan;
            });
    });

    $table.off("click.setAttrDataOfFromTableHeaders", "tbody td.generatesummary");
    $table.on(
        "click.setAttrDataOfFromTableHeaders",
        "tbody td.generatesummary",
        function () {
            const $clickedTd = $(this);
            const $row = $clickedTd.closest("tr");
            const rowdata = [];

            $row.children("td").each(function () {
                if ($(this).hasClass("d-none") || $(this).css("display") === "none") {
                    return;
                }

                rowdata.push({
                    tdname: (($(this).attr("attr-data-of") || "") + "").trim(),
                    tdvalue: (($(this).text() || "") + "").replace(/\s+/g, " ").trim(),
                });
            });

            const payload = {
                asofdate: $table.attr("asofdate"),
                widgetname: ((
                    $clickedTd.closest("span[data-comp]").attr("data-comp") || ""
                ) + "").trim(),
                tdclickname: ((($clickedTd.attr("attr-data-of") || "") + "").trim()),
                tdclickvalue: ((($clickedTd.text() || "") + "").replace(/\s+/g, " ").trim()),
                rowdata,
            };

            $clickedTd.data("generatesummarypayload", payload);
            $table.data("lastgeneratesummarypayload", payload);
            $table.trigger("generatesummaryclick", [payload]);
            /*console.log("Summary Payload", payload)*/
        }
    );
}

// Helper function to prepare table for export
function prepareTableForExport(table) {

    // Show full header text from data-export attribute
    $(table)
        .find("th[data-export]")
        .each(function () {
            $(this).text($(this).attr("data-export"));
        });

    // Remove unwanted elements
    $(table).find("select").remove();
    $(table).find("input").remove();
    $(table).find("img").remove();
    $(table).find(".label-radio.form-check-label").remove();
    $(table).find(".d-none").remove();

    return table;
}

function fnConvertSnapShotInTable(
    tableid,
    filename,
    snapshotid,
    isfullsnapshot
) {

    var tableHTML = "";
    if (isfullsnapshot) {
        $("#" + snapshotid)
            .find("[import]")
            .each(function () {
                var tableids = $(this).attr("import").split(",");
                if (tableids.length === 1) {
                    if ($("#" + tableids[0]).length > 0) {
                        var tableSelect = $("#" + tableids[0]).clone();

                        // Prepare table
                        tableSelect = prepareTableForExport(tableSelect);

                        var Header = $("#" + tableids[0])
                            .parents(".snapshotrow")
                            .attr("rowtitle");
                        var MainHeaderColspan = 0;
                        $(tableSelect)
                            .find("thead")
                            .find("tr:first th")
                            .each(function () {
                                var colspan = $(this).attr("colspan");
                                if (colspan != null && colspan != undefined && colspan != "") {
                                    MainHeaderColspan = MainHeaderColspan + parseInt(colspan);
                                } else {
                                    MainHeaderColspan = MainHeaderColspan + 1;
                                }
                            });
                        $(tableSelect)
                            .find("thead")
                            .prepend(
                                "<tr><td colspan='" +
                                MainHeaderColspan +
                                "'><h3>" +
                                Header +
                                "</h3></td></tr>"
                            );
                        $(tableSelect).attr("border", "1");

                        tableHTML = tableHTML + $(tableSelect)[0].outerHTML;
                    }
                } else {
                    if ($("#" + tableids[0]).length > 0) {
                        let tableSelect = $("#" + tableids[0]).clone();
                        for (let i = 1; i < tableids.length; i++) {
                            var temp = $("#" + tableids[i]);
                            $(temp)
                                .find("tr")
                                .each(function (rowno) {
                                    $(this)
                                        .find("td,th")
                                        .each(function (colno) {
                                            if (!$(this).hasClass("d-none")) {
                                                tableSelect.find("tr").eq(rowno).append($(this).clone());
                                            }
                                        });
                                });
                        }

                        // Prepare table
                        tableSelect = prepareTableForExport(tableSelect);

                        var Header = $("#" + tableids[0])
                            .parents(".snapshotrow")
                            .attr("rowtitle");
                        var MainHeaderColspan = 0;
                        $(tableSelect)
                            .find("thead")
                            .find("tr:first th")
                            .each(function () {
                                var colspan = $(this).attr("colspan");
                                if (colspan != null && colspan != undefined && colspan != "") {
                                    MainHeaderColspan = MainHeaderColspan + parseInt(colspan);
                                } else {
                                    MainHeaderColspan = MainHeaderColspan + 1;
                                }
                            });
                        $(tableSelect)
                            .find("thead")
                            .prepend(
                                "<tr><td colspan='" +
                                MainHeaderColspan +
                                "'><h3>" +
                                Header +
                                "</h3></td></tr>"
                            );
                        $(tableSelect).attr("border", "1");
                        tableHTML = tableHTML + $(tableSelect)[0].outerHTML;
                    }
                }
            });
    } else {
        var tableids = tableid.split(",");

        if (tableids.length === 1) {
            if ($("#" + tableids[0]).length > 0) {
                var tableSelect = $("#" + tableids[0]).clone();

                // Prepare table
                tableSelect = prepareTableForExport(tableSelect);

                var Header = $("#" + tableids[0])
                    .parents(".snapshotrow")
                    .attr("rowtitle");
                var MainHeaderColspan = 0;

                $(tableSelect)
                    .find("thead")
                    .find("tr:first th")
                    .each(function () {
                        var colspan = $(this).attr("colspan");
                        if (colspan != null && colspan != undefined && colspan != "") {
                            MainHeaderColspan = MainHeaderColspan + parseInt(colspan);
                        } else {
                            MainHeaderColspan = MainHeaderColspan + 1;
                        }
                    });
                $(tableSelect)
                    .find("thead")
                    .prepend(
                        "<tr><td colspan='" + MainHeaderColspan + "'><h3>" + Header + "</h3></td></tr>"
                    );
                $(tableSelect).attr("border", "1");

                tableHTML = $(tableSelect)[0].outerHTML;
            }
        } else {
            if ($("#" + tableids[0]).length > 0) {
                let tableSelect = $("#" + tableids[0]).clone();
                for (let i = 1; i < tableids.length; i++) {
                    var temp = $("#" + tableids[i]);
                    $(temp)
                        .find("tr")
                        .each(function (rowno) {
                            $(this)
                                .find("td,th")
                                .each(function (colno) {
                                    if (!$(this).hasClass("d-none")) {
                                        tableSelect.find("tr").eq(rowno).append($(this).clone());
                                    }
                                });
                        });
                }

                // Prepare table
                tableSelect = prepareTableForExport(tableSelect);

                var Header = $("#" + tableids[0])
                    .parents(".snapshotrow")
                    .attr("rowtitle");
                var MainHeaderColspan = 0;
                $(tableSelect)
                    .find("thead")
                    .find("tr:first th")
                    .each(function () {
                        var colspan = $(this).attr("colspan");
                        if (colspan != null && colspan != undefined && colspan != "") {
                            MainHeaderColspan = MainHeaderColspan + parseInt(colspan);
                        } else {
                            MainHeaderColspan = MainHeaderColspan + 1;
                        }
                    });
                $(tableSelect)
                    .find("thead")
                    .prepend(
                        "<tr><td colspan='" + MainHeaderColspan + "'><h3>" + Header + "</h3></td></tr>"
                    );
                $(tableSelect).attr("border", "1");
                tableHTML = $(tableSelect)[0].outerHTML;
            }
        }
    }
    return tableHTML;
}

// function fnExportInCSV(tableid, filename) {

//     var tableHTML = fnConvertSnapShotInTable(tableid, filename, "", false);
//     tableHTML = encodeURIComponent(tableHTML);
//     var downloadLink;
//     downloadLink = document.createElement("a");
//     document.body.appendChild(downloadLink);
//     filename = filename ? filename + ".xls" : "excel_data.xls";
//     var dataType = "application/vnd.ms-excel";
//     if (navigator.msSaveOrOpenBlob) {
//         var blob = new Blob(["\ufeff", tableHTML], {
//             type: dataType,
//         });
//         navigator.msSaveOrOpenBlob(blob, filename);
//     } else {
//         downloadLink.href = "data:" + dataType + ", " + tableHTML;
//         downloadLink.download = filename;
//         downloadLink.click();
//     }
// }

function fnExportInCSV(tableid, filename) {
    let tableHTML = fnConvertSnapShotInTable(tableid, filename, "", false);

    filename = filename
        ? filename + ".xls"
        : "excel_data.xls";

    // Proper Excel HTML structure with UTF-8 support
    const excelFile = `
        <html xmlns:o="urn:schemas-microsoft-com:office:office"
              xmlns:x="urn:schemas-microsoft-com:office:excel"
              xmlns="http://www.w3.org/TR/REC-html40">
        <head>
            <meta charset="UTF-8">
        </head>
        <body>
            ${tableHTML}
        </body>
        </html>
    `;

    const dataType =
        "application/vnd.ms-excel;charset=utf-8;";

    // Create Blob
    const blob = new Blob(
        ["\ufeff", excelFile],
        { type: dataType }
    );

    // Download link
    const downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);

    // IE Support
    if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
    } else {
        const url = URL.createObjectURL(blob);

        downloadLink.href = url;
        downloadLink.download = filename;
        downloadLink.style.display = "none";

        downloadLink.click();

        URL.revokeObjectURL(url);
    }

    document.body.removeChild(downloadLink);
}

// function fnExportSnapShotInCSV(snapshotid, filename) {
//     var tableHTML = fnConvertSnapShotInTable("", filename, snapshotid, true);
//     tableHTML = encodeURIComponent(tableHTML);
//     var downloadLink;
//     downloadLink = document.createElement("a");
//     document.body.appendChild(downloadLink);
//     filename = filename ? filename + ".xls" : "excel_data.xls";
//     var dataType = "application/vnd.ms-excel";
//     if (navigator.msSaveOrOpenBlob) {
//         var blob = new Blob(["\ufeff", tableHTML], {
//             type: dataType,
//         });
//         navigator.msSaveOrOpenBlob(blob, filename);
//     } else {
//         downloadLink.href = "data:" + dataType + ", " + tableHTML;
//         downloadLink.download = filename;
//         downloadLink.click();
//     }
// }

function fnExportSnapShotInCSV(snapshotid, filename) {

    let tableHTML = fnConvertSnapShotInTable(
        "",
        filename,
        snapshotid,
        true
    );

    filename = filename
        ? filename + ".xls"
        : "excel_data.xls";

    // Proper Excel HTML format with UTF-8 encoding
    const excelFile = `
        <html xmlns:o="urn:schemas-microsoft-com:office:office"
              xmlns:x="urn:schemas-microsoft-com:office:excel"
              xmlns="http://www.w3.org/TR/REC-html40">
        <head>
            <meta charset="UTF-8">
        </head>
        <body>
            ${tableHTML}
        </body>
        </html>
    `;

    const dataType =
        "application/vnd.ms-excel;charset=utf-8;";

    // Create Blob
    const blob = new Blob(
        ["\ufeff", excelFile],
        { type: dataType }
    );

    // Create download link
    const downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);

    // IE Support
    if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
    } else {

        const url = URL.createObjectURL(blob);

        downloadLink.href = url;
        downloadLink.download = filename;
        downloadLink.style.display = "none";

        downloadLink.click();

        // Cleanup
        URL.revokeObjectURL(url);
    }

    document.body.removeChild(downloadLink);
}

//snapshotmailtype = EXCEL , HTML
function fnSendWidgetMail(
    tableid,
    filename,
    snapshotid,
    asofdata,
    sendtoemails,
    widgetid = 0,
    snapshotmailtype = "EXCEL"
) {
    var tableHTML = fnConvertSnapShotInTable(tableid, filename, "", false);
    try {
        let formData = new FormData();
        formData.append("snapshotid", snapshotid);
        formData.append("widgetid", widgetid);
        formData.append("html", tableHTML);
        formData.append("asofdata", getDateInFormat(asofdata));
        formData.append("sendtoemails", sendtoemails);
        formData.append("snapshotmailtype", snapshotmailtype);
        formData.append(
            "propertyname",
            $(".snapshot-property-details").attr("propertyname")
                ? $(".snapshot-property-details").attr("propertyname")
                : ""
        );
        formData.append(
            "propertycode",
            $(".snapshot-property-details").attr("propertycode")
                ? $(".snapshot-property-details").attr("propertycode")
                : ""
        );

        let response = axios({
            method: "POST",
            url: API_URL.BASE_API_URL.Configuration + API_URL.SNAPSHOT.SNAPSHOT_MAIL,
            data: formData,
            headers: commonService.getHeadersFromData(),
        }).then((res) => {
            if (res.data.status_code === 1) {
                successToastMessage(res?.data?.message);
            } else {
                errorToastMessage(res?.data?.message);
            }
        });
    } catch (error) { }
}

function fnSendtSnapShotMail(
    pagesnapshotid,
    filename,
    snapshotid,
    asofdata,
    sendtoemails,
    widgetid = 0,
    snapshotmailtype = "EXCEL"
) {
    var tableHTML = fnConvertSnapShotInTable("", filename, pagesnapshotid, true);

    try {
        let formData = new FormData();
        formData.append("snapshotid", snapshotid);
        formData.append("widgetid", widgetid);
        formData.append("html", tableHTML);
        formData.append("asofdata", getDateInFormat(asofdata));
        formData.append("sendtoemails", sendtoemails);
        formData.append("snapshotmailtype", snapshotmailtype);
        formData.append(
            "propertyname",
            $(".snapshot-property-details").attr("propertyname")
                ? $(".snapshot-property-details").attr("propertyname")
                : ""
        );
        formData.append(
            "propertycode",
            $(".snapshot-property-details").attr("propertycode")
                ? $(".snapshot-property-details").attr("propertycode")
                : ""
        );

        let response = axios({
            method: "POST",
            url: API_URL.BASE_API_URL.Configuration + API_URL.SNAPSHOT.SNAPSHOT_MAIL,
            data: formData,
            headers: commonService.getHeadersFromData(),
        }).then((res) => {
            if (res.data.status_code === 1) {
                successToastMessage(res?.data?.message);
            } else {
                errorToastMessage(res?.data?.message);
            }
        });
    } catch (error) { }
}

function fnExportChartInCSV(chartid, filename) {
    const canvas = document.getElementById(chartid);
    var img = canvas.toDataURL("image/jpeg", 1); //image data of canvas

    var a = document.createElement("a"); //Create <a>
    //a.href = "data:image/png;base64," + ImageBase64;
    a.href = img;
    a.download = filename + ".jpeg"; //File name Here
    a.click();
    var uri = "data:application/vnd.ms-excel;base64,",
        template =
            '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><img src="{table}" alt="grafica" /></body></html>',
        base64 = function (s) {
            return window.btoa(unescape(encodeURIComponent(s)));
        },
        format = function (s, c) {
            return s.replace(/{(\w+)}/g, function (m, p) {
                return c[p];
            });
        };

    var ctx = { worksheet: filename || "Hoja1", table: filename + ".jpeg" };
    //window.location.href = uri + base64(format(template, ctx))
    var link = document.createElement("a");
    link.download = filename + ".xls";
    link.href = uri + base64(format(template, ctx));
    link.click();
}

function setBackColorPerByTDValue(
    positiveColor,
    negativeColor,
    Container,
    DivClassName
) {
    if (positiveColor) {
        if (positiveColor.toUpperCase() === "#638EC6") {
            positiveColor = "#cee1f8";
        }

        if (positiveColor.toUpperCase() === "GREEN") {
            positiveColor = "#aae5b0";
        }

        if (positiveColor.toUpperCase() === "RED") {
            positiveColor = "#ffb4b4";
        }
    }

    if (negativeColor) {
        if (negativeColor.toUpperCase() === "#638EC6") {
            negativeColor = "#cee1f8";
        }

        if (negativeColor.toUpperCase() === "GREEN") {
            negativeColor = "#aae5b0";
        }

        if (negativeColor.toUpperCase() === "RED") {
            negativeColor = "#ffb4b4";
        }
    }

    $(document).ready(function () {
        var MaxValue = 0;
        $(Container).each(function () {
            let DTVal = $(this).attr("value");
            if (DTVal !== null && DTVal !== undefined && DTVal !== 0) {
                if (parseFloat(DTVal) > MaxValue) {
                    MaxValue = parseFloat(DTVal);
                } else if (parseFloat(DTVal) < 0) {
                    if (parseFloat(DTVal) * -1 > MaxValue) {
                        MaxValue = parseFloat(DTVal) * -1;
                    }
                }
            }
        });

        $(Container).each(function () {
            let Color = positiveColor;
            let ColorPer = 0;
            let DefaultColorPer = 100;
            let DTVal = $(this).attr("value");
            if (DTVal !== null && DTVal !== undefined && DTVal !== 0) {
                if (
                    parseFloat(DTVal) !== null &&
                    parseFloat(DTVal) !== undefined &&
                    parseFloat(DTVal) !== 0
                ) {
                    if (parseFloat(DTVal) < 0) {
                        DTVal = parseFloat(DTVal) * -1;
                        Color = negativeColor;
                    }
                    ColorPer = Math.round((parseFloat(DTVal) * 100) / MaxValue);
                }
            }
            $(this).find(".bgdiv").remove();
            $(this).css("position", "relative");
            $(this).css("z-index", "1");
            let widthStyle = "calc(" + ColorPer + "% - 0px)";
            $(this).append(
                "<div class='bgdiv " +
                DivClassName +
                "' style='width:" +
                widthStyle +
                ";background:" +
                Color +
                ";'></div>"
            );
        });
    });
}


function setBackColorPerByTDValueInPercentage(
    positiveColor,
    negativeColor,
    Container,
    DivClassName
) {
    if (positiveColor) {
        if (positiveColor.toUpperCase() === "#638EC6") {
            positiveColor = "#cee1f8";
        }

        if (positiveColor.toUpperCase() === "GREEN") {
            positiveColor = "#aae5b0";
        }

        if (positiveColor.toUpperCase() === "RED") {
            positiveColor = "#ffb4b4";
        }
    }

    if (negativeColor) {
        if (negativeColor.toUpperCase() === "#638EC6") {
            negativeColor = "#cee1f8";
        }

        if (negativeColor.toUpperCase() === "GREEN") {
            negativeColor = "#aae5b0";
        }

        if (negativeColor.toUpperCase() === "RED") {
            negativeColor = "#ffb4b4";
        }
    }

    $(document).ready(function () {
        var MaxValue = 100;

        $(Container).each(function () {
            let Color = positiveColor;
            let ColorPer = 0;
            let DefaultColorPer = 100;
            let DTVal = $(this).attr("value");
            if (DTVal !== null && DTVal !== undefined && DTVal !== 0) {
                if (
                    parseFloat(DTVal) !== null &&
                    parseFloat(DTVal) !== undefined &&
                    parseFloat(DTVal) !== 0
                ) {
                    if (parseFloat(DTVal) < 0) {
                        DTVal = parseFloat(DTVal) * -1;
                        Color = negativeColor;
                    }
                    ColorPer = Math.round((parseFloat(DTVal) * 100) / MaxValue);
                }
            }
            $(this).find(".bgdiv").remove();
            $(this).css("position", "relative");
            $(this).css("z-index", "1");
            let widthStyle = "calc(" + ColorPer + "% - 0px)";
            $(this).append(
                "<div class='bgdiv " +
                DivClassName +
                "' style='width:" +
                widthStyle +
                ";background:" +
                Color +
                ";'></div>"
            );
        });
    });
}





function setBackColorWithCompareSameTDIndex(
    ColorsInRGB,
    Container,
    MinOpacity
) {

    $(document).ready(function () {
        var MaxValue = 0;
        $(Container).each(function () {
            let DTVal = $(this).attr("value");
            if (DTVal !== null && DTVal !== undefined && DTVal !== 0) {
                if (parseFloat(DTVal) > MaxValue) {
                    MaxValue = parseFloat(DTVal);
                } else if (parseFloat(DTVal) < 0) {
                    if (parseFloat(DTVal) * -1 > MaxValue) {
                        MaxValue = parseFloat(DTVal) * -1;
                    }
                }
            }
        });

        $(Container).each(function () {
            let Color = ColorsInRGB;
            let ColorPer = 0;
            let DTVal = $(this).attr("value");
            if (DTVal !== null && DTVal !== undefined && DTVal !== 0) {
                if (
                    parseFloat(DTVal) !== null &&
                    parseFloat(DTVal) !== undefined &&
                    parseFloat(DTVal) !== 0
                ) {

                    ColorPer = MinOpacity + (Math.round((parseFloat(DTVal) * 100) / MaxValue) / 100);
                    $(this).css("background-color", Color.replace("DIFF", ColorPer))
                }
            }
        });
    });
}

function ShortArray(array, key) {
    return array.sort(function (a, b) {
        var x = a[key];
        var y = b[key];
        return x < y ? -1 : x > y ? 1 : 0;
    });
}

function FloatValueToFixed(value) {
    if (!/[a-zA-Z]/.test(value)) {
        const regex = /^\d*\.?\d{0,2}$/;
        if (regex.test(value) || value === "") {
            return value;
        } else {
            let splitedValue = value.includes(".") ? value?.split(".")[1] : value;
            if (splitedValue.length > 2) {
                return parseFloat(value).toFixed(2);
            } else {
                return value;
            }
        }
    }
}

function convertDateInTimezone(date) {
    let convertedDate = "";
    if (date) {
        convertedDate = moment(date).toDate();
    }
    return convertedDate;
}

function getLastYearDate(date) {
    let convertedDate = "";
    if (date) {
        let year = moment(date).toDate().getFullYear() - 1;
        let month = moment(date).toDate().getMonth();
        let date = moment(date).toDate().getDate();
        let d = new Date(year, month, date);
        convertedDate = moment(d).toDate();
    }
    return convertedDate;
}

async function widgetWiseExportExcel(payload) {
    // document.getElementById("root").classList.add("bodyLoader");

    toast(
        <>
            <div className="card-title h6" data_details={"data.details"}>
                {"Your request in progress."}
            </div>
            <p className="card-text pt-2">
                {payload.actiontype === "DOWNLOAD"
                    ? "Excel will be download automatically,don't close browser until download."
                    : "Email will be send after process."}
            </p>
        </>,
        {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "dark",
        }
    );

    let exportExcelResponse = await apiCall(
        {
            method: "POST",
            url: API_URL.BASE_API_URL.SnapShot + API_URL.NODE_EXPORT_WIDGET_WISE_EXCEL.NODE_EXPORT_WIDGET_WISE_EXCEL,
            body: payload,
        },
        false
    );

    let response = apiResponse(false, exportExcelResponse);

    if (response?.isValidate) {
        if (payload.actiontype === "DOWNLOAD") {
            const baseUrl = API_URL.BASE_API_URL.SnapShot?.replace("api/", "");
            window.open(`${baseUrl}/public/${response?.data?.data}`, "_blank");
        } else {
            const userDetail = commonService.getLoginUserData();
            let exportExcelResponseForMail = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASE_API_URL.Configuration + API_URL.SNAPSHOT.SANAPSHOTREVPAKMAIL,
                    body: {
                        filename: response?.data?.data,
                        snapshotid: payload.snapshotId ? parseInt(payload.snapshotId) : 0,
                        sendtoemails: payload.sendtoemails ? payload.sendtoemails : "",
                        asofdata: payload.asofdata ? commonService.getDateInDBFormat(payload.asofdata) : ""
                    },
                },
                false
            );
            successToastMessage("Email send successFully");
        }
        // document.getElementById("root").classList.remove("bodyLoader");
    }

    if (!response?.isValidate) {
        errorToastMessage(response?.message);
        // document.getElementById("root").classList.remove("bodyLoader");
    }
}

function generateRandomColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

function getWeekStartAndEndDate(date) {
    const currentDate = new Date(date);

    const weekStart = new Date(currentDate);
    weekStart.setDate(currentDate.getDate() - currentDate.getDay());

    const weekEnd = new Date(currentDate);
    weekEnd.setDate(currentDate.getDate() + (6 - currentDate.getDay()));

    return {
        start: weekStart,
        end: weekEnd,
    };
}

function formateAmount(amount, currency) {
    if (!amount && amount !== "0" && amount !== 0) {
        return "";
    } else {
        amount = Math.round(amount);
    }
    let USDollar = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    });
    let formatedAmount = USDollar.format(amount);
    let replacedValue = formatedAmount?.replace(".00", "");
    let findSelectedPropertyData = getItem("property");
    if (findSelectedPropertyData) {
        findSelectedPropertyData = JSON.parse(findSelectedPropertyData);
    }
    let finalValue = "$";
    if (findSelectedPropertyData) {
        finalValue = replacedValue?.replace(
            "$",
            `${currency
                ? currency
                : findSelectedPropertyData?.currency_term
                    ? `${findSelectedPropertyData?.currency_term}`
                    : "$"
            }`
        );
    } else {
        let defaultCurrencyFromLocal = getItem("defaultCurrency");
        if (defaultCurrencyFromLocal) {
            let json = JSON.parse(defaultCurrencyFromLocal);
            finalValue = replacedValue?.replace(
                "$",
                `${json?.currency
                // currency
                //   ? currency
                //   : findSelectedPropertyData?.currency_term
                //   ? `${findSelectedPropertyData?.currency_term}`
                //   : "$"
                }`
            );
        }
    }
    return finalValue;
}

function formateRoom(room) {
    if (!room && room !== "0" && room !== 0) {
        return "";
    }
    let USDollar = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    });
    let formatedAmount = USDollar.format(room);
    let replacedValue = formatedAmount?.replace(".00", "");
    let finalValue = replacedValue?.replace("$", "");
    return finalValue;
}

function getMonthNamesUntil(date) {
    const monthList = [];
    let selectedDate = new Date(date);

    month?.forEach((item, index) => {
        if (index <= selectedDate.getMonth()) {
            monthList.push(item);
        }
    });

    return monthList;
}

function fnArchive(snapshotdetails, asofdate, propertycode) {
    $("#snapshot_" + snapshotdetails.snapshotid)
        .find("img.chartimg")
        .remove();

    $("#snapshot_" + snapshotdetails.snapshotid)
        .find("canvas")
        .each(function () {
            $(this)
                .parent()
                .append(
                    "<img class='chartimg' style=display:none; src=" +
                    this.toDataURL() +
                    " />"
                );
        });

    let snapshot = $("#snapshot_" + snapshotdetails.snapshotid).clone();
    $(snapshot).find("canvas").remove();
    $(snapshot).find("img.chartimg").css("display", "block");
    $(snapshot).find("select").remove();
    $(snapshot).find("input").remove();
    $(snapshot).find("button").replaceWith("<span></span>");
    $(snapshot).find(".react-datepicker-wrapper").remove();
    $(snapshot).find(".p-multiselect").remove();
    $(snapshot).find(".widget-container-menu").remove();
    $(snapshot).find(".make-comment-in-widget").remove();
    $(snapshot).find("table img").remove();
    $(snapshot).find(".label-radio.form-check-label").remove();
    $(snapshot).find("span").css("display", "block");

    let formData = new FormData();
    formData.append("asofdate", asofdate);
    formData.append("propertycode", propertycode);
    formData.append("propertyid", snapshotdetails.propertyid);
    formData.append(
        "archivetype",
        snapshotdetails.category + "_" + snapshotdetails.snapshottitle
    );
    formData.append("archivehtml", $(snapshot).html());

    axios({
        method: "POST",
        url: API_URL.BASE_API_URL.Notification + API_URL.ARCHIVE.SAVE,
        data: formData,
        headers: commonService.getHeadersFromData(),
    }).then((res) => {
        if (res.data.status_code === 1) {
            successToastMessage(res?.data?.message);
        } else {
            errorToastMessage(res?.data?.message);
        }
    });
    /*$("#snapshot_" + snapshotdetails.snapshotid).append(snapshot);*/
}

function convertsnapshotToImg(snapshotdetails, asofdate, propertycode) {
    let snapshot = $("#snapshot_" + snapshotdetails.snapshotid).clone();
    // $(snapshot).find("canvas").remove();
    // $(snapshot).find("img.chartimg").css("display", "block");
    $(snapshot).find("select").remove();
    $(snapshot).find("input").remove();
    // $(snapshot).find("button").replaceWith("<span></span>");
    $(snapshot).find("button").remove();
    $(snapshot).find(".react-datepicker-wrapper").remove();
    $(snapshot).find(".p-multiselect").remove();
    // $(snapshot).find(".widget-container-menu").remove();
    $(snapshot).find(".make-comment-in-widget").remove();
    // $(snapshot).find("table img").remove();
    $(snapshot).find(".label-radio.form-check-label").remove();
    $(snapshot).find("span").css("display", "block");

    let htmlData = $(snapshot).html();

    var iframe = document.createElement("div");
    iframe.setAttribute("id", "snapshotArchiveFn");
    iframe.innerHTML = htmlData;
    document.body.appendChild(iframe);

    setTimeout(function () {
        html2canvas(
            // document.querySelector(`#snapshot_${snapshotdetails.snapshotid}`)
            document.querySelector("#snapshotArchiveFn")
        ).then((canvas) => {
            let base64 = canvas?.toDataURL();

            let imgHTML = `<img src='${base64}' />`;

            let formData = new FormData();
            formData.append("asofdate", asofdate);
            formData.append("propertycode", propertycode);
            formData.append("propertyid", snapshotdetails.propertyid);
            formData.append(
                "archivetype",
                snapshotdetails.category + "_" + snapshotdetails.snapshottitle
            );
            formData.append("archivehtml", imgHTML);

            // axios({
            //   method: "POST",
            //   url: API_URL.BASE_API_URL.Notification + API_URL.ARCHIVE.SAVE,
            //   data: formData,
            //   headers: commonService.getHeadersFromData(),
            // }).then((res) => {
            //   if (res.data.status_code === 1) {
            //     successToastMessage(res?.data?.message);
            //   } else {
            //     errorToastMessage(res?.data?.message);
            //   }
            // });
        });
    }, 10);
}

function stringToHtmlTableExport(tableHTML, filename) {
    tableHTML = encodeURIComponent(tableHTML);
    var downloadLink;
    downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);
    filename = filename ? filename + ".xls" : "excel_data.xls";
    var dataType = "application/vnd.ms-excel";
    if (navigator.msSaveOrOpenBlob) {
        var blob = new Blob(["\ufeff", tableHTML], {
            type: dataType,
        });
        navigator.msSaveOrOpenBlob(blob, filename);
    } else {
        downloadLink.href = "data:" + dataType + ", " + tableHTML;
        downloadLink.download = filename;
        downloadLink.click();
    }
}

function fnSetMainAndSubDomain() {
    setItem("RmCopilotSD", "https://rmcopilot.hotelswitchboard.com");
    if (window.location.origin.toLowerCase().includes("hotelswitchboard.com")) {
        setItem("RevenueSD", "https://revevolve.hotelswitchboard.com");
        setItem("RateshopSD", "https://rateshop.hotelswitchboard.com");
        setItem("RmCopilotSD", "https://rmcopilot.hotelswitchboard.com");
        setItem("MD", "https://hotelswitchboard.com");

        if (window.location.href?.includes("/revevolve.")) {
            setItem("SD", "https://revevolve.hotelswitchboard.com");
        }
        else if (window.location.href?.includes("/rateshop.")) {
            setItem("SD", "https://rateshop.hotelswitchboard.com");
        }
        else if (window.location.href?.includes("/rmcopilot.")) {
            setItem("SD", "https://rmcopilot.hotelswitchboard.com");
        }
        else {
            setItem("SD", "https://hotelswitchboard.com");
        }
    }
    else if (window.location.origin.toLowerCase().includes("mhorm.com")) {
        setItem("RevenueSD", "https://bi.mhorm.com");
        setItem("RateshopSD", "https://rateshop.mhorm.com");
        setItem("RmCopilotSD", "https://rmcopilot.hotelswitchboard.com");
        setItem("MD", "https://bi.mhorm.com");
        if (window.location.href?.includes("/revenue.")) {
            setItem("SD", "https://bi.mhorm.com");
        }
        else if (window.location.href?.includes("/rateshop.")) {
            setItem("SD", "https://rateshop.mhorm.com");
        }
        else if (window.location.href?.includes("/rmcopilot.")) {
            setItem("SD", "https://rmcopilot.mhorm.com");
        }
        else {
            setItem("SD", "https://bi.mhorm.com");
        }
    }
    else if (window.location.origin.toLowerCase().includes("revnomix.com")) {
        setItem("RevenueSD", "https://ai.revnomix.com");
        setItem("RateshopSD", "https://ai.revnomix.com");
        setItem("RmCopilotSD", "https://rmcopilot.hotelswitchboard.com");
        setItem("MD", "https://ai.revnomix.com");

        if (window.location.href?.includes("/revenue.")) {
            setItem("SD", "https://ai.revnomix.com");
        }
        else if (window.location.href?.includes("/rateshop.")) {
            setItem("SD", "https://ai.revnomix.com");
        }
        else if (window.location.href?.includes("/rmcopilot.")) {
            setItem("SD", "https://rmcopilot.revnomix.com");
        }
        else {
            setItem("SD", "https://ai.revnomix.com");
        }
    }
    else if (window.location.origin.toLowerCase().includes("rategain.com")) {
        setItem("RevenueSD", "https://navigatorBI.rategain.com");
        setItem("RateshopSD", "https://navigatorBI.rategain.com");
        setItem("RmCopilotSD", "https://rmcopilot.hotelswitchboard.com");
        setItem("MD", "https://navigatorBI.rategain.com");

        if (window.location.href?.includes("/revenue.")) {
            setItem("SD", "https://navigatorBI.rategain.com");
        }
        else if (window.location.href?.includes("/rateshop.")) {
            setItem("SD", "https://navigatorBI.rategain.com");
        }
        else if (window.location.href?.includes("/rmcopilot.")) {
            setItem("SD", "https://navigatorBI.rategain.com");
        }
        else {
            setItem("SD", "https://navigatorBI.rategain.com");
        }
    }
    else if (window.location.origin.toLowerCase().includes("bi.nxtgenrm.com")) {
        setItem("RevenueSD", "https://bi.nxtgenrm.com");
        setItem("RateshopSD", "https://bi.nxtgenrm.com");
        setItem("RmCopilotSD", "https://rmcopilot.hotelswitchboard.com");
        setItem("MD", "https://bi.nxtgenrm.com");

        if (window.location.href?.includes("/revenue.")) {
            setItem("SD", "https://bi.nxtgenrm.com");
        }
        else if (window.location.href?.includes("/rateshop.")) {
            setItem("SD", "https://bi.nxtgenrm.com");
        }
        else if (window.location.href?.includes("/rmcopilot.")) {
            setItem("SD", "https://bi.nxtgenrm.com");
        }
        else {
            setItem("SD", "https://bi.nxtgenrm.com");
        }
    }
}

function ClearLocalStorage() {
    //localStorage.removeItem("property");
    localStorage.removeItem("userRights");
    localStorage.removeItem("userDetail");
    localStorage.removeItem("tokenid");
    localStorage.removeItem("token");
    localStorage.removeItem("defaultCurrency");
    localStorage.removeItem("sid");
}

function LogOutToUser() {
    const searchParams = new URLSearchParams(window.location.search);
    let redirect = "";
    let mod = "";
    let p = "";

    if (searchParams.has('redirect')) {
        redirect = searchParams.get('redirect');
    }

    if (searchParams.has('mod')) {
        mod = searchParams.get('mod');
    }

    if (searchParams.has('p')) {
        p = searchParams.get('p');
    }

    ClearLocalStorage();
    if (redirect !== null && redirect !== undefined && redirect !== "" && p !== null && p !== undefined && p !== "" && mod !== null && mod !== undefined && mod !== "") {
        window.location.href = commonService.getItem("MD") + "?logout=true&redirect=" + redirect + "&mod=" + mod + "&p=" + p;
    }
    else {
        window.location.href = commonService.getItem("MD") + "?logout=true"
    }

}

function GetLogo() {
    let loginLogo = EMA_loginLogo;
    let logo = EMA_logo;

    if (
        window.location.origin
            .toLowerCase()
            .indexOf("revevolve.hotelswitchboard.com") >= 0
    ) {
        logo = EMA_RevEvolve;
    }

    if (window.location.origin.toLowerCase().indexOf("ai.revnomix.com") >= 0) {
        loginLogo = revnomix_loginLogo;
        logo = revnomix_RevEvolve;
    }
    else if (window.location.origin.toLowerCase().indexOf("rms.envision-hospitality.com") >= 0) {
        loginLogo = EnvisionHospitality_loginLogo;
        logo = EnvisionHospitality_RevEvolve;
    }
    else if (window.location.origin.toLowerCase().indexOf("mhorm.com") >= 0) {
        loginLogo = mho_loginLogo;
        logo = mho_RevEvolve;
    }
    else if (window.location.origin.toLowerCase().indexOf("rategain.com") >= 0) {
        loginLogo = rategain_loginLogo;
        logo = rategain_RevEvolve;
    }
    else if (window.location.origin.toLowerCase().indexOf("bi.nxtgenrm.com") >= 0) {
        loginLogo = NextGen_loginLogo;
        logo = NextGen_RevEvolve;
    }

    return { loginLogo: loginLogo, logo: logo };
}

function GetRevenueModuleHTML() {
    if (
        window.location.origin.toLowerCase().indexOf("hotelswitchboard.com") >= 0
    ) {
        return (
            <div className={`dbBoxes revEvolveBg`}>
                <div className="side-arrow">
                    <img src={sideArrow} alt="arrow" />
                </div>
            </div>
        );
    } else if (
        window.location.origin.toLowerCase().indexOf("ai.revnomix.com") >= 0
    ) {
        return (
            <div className="dbBoxes">
                <div className="dbBoxImgTitle">
                    <img className="dbBoxImg" src={dbaccounting} alt="config" />
                    <h3>RevnomixBI</h3>
                </div>
                <div className="side-arrow">
                    <img src={sideArrow} alt="arrow" />
                </div>
            </div>
        );
    } else if (
        window.location.origin.toLowerCase().indexOf("rms.envision-hospitality.com") >= 0
    ) {
        return (
            <div className="dbBoxes">
                <div className="dbBoxImgTitle">
                    <img className="dbBoxImg" src={dbaccounting} alt="config" />
                    <h3>EnvisionBI</h3>
                </div>
                <div className="side-arrow">
                    <img src={sideArrow} alt="arrow" />
                </div>
            </div>
        );
    } else if (
        window.location.origin.toLowerCase().indexOf("mhorm.com") >= 0
    ) {
        return (
            <div className="dbBoxes">
                <div className="dbBoxImgTitle">
                    <img className="dbBoxImg" src={dbaccounting} alt="config" />
                    <h3>MHOBI</h3>
                </div>
                <div className="side-arrow">
                    <img src={sideArrow} alt="arrow" />
                </div>
            </div>
        );
    } else if (
        window.location.origin.toLowerCase().indexOf("rategain.com") >= 0
    ) {
        return (
            <div className="dbBoxes">
                <div className="dbBoxImgTitle">
                    <img className="dbBoxImg" src={dbaccounting} alt="config" />
                    <h3>NavigatorBI</h3>
                </div>
                <div className="side-arrow">
                    <img src={sideArrow} alt="arrow" />
                </div>
            </div>
        );
    } else if (
        window.location.origin.toLowerCase().indexOf("bi.nxtgenrm.com") >= 0
    ) {
        return (
            <div className="dbBoxes">
                <div className="dbBoxImgTitle">
                    <img className="dbBoxImg" src={dbaccounting} alt="config" />
                    <h3>NXTGenBI</h3>
                </div>
                <div className="side-arrow">
                    <img src={sideArrow} alt="arrow" />
                </div>
            </div>
        );
    } else {
        return (
            <div className="dbBoxes">
                <div className="dbBoxImgTitle">
                    <img className="dbBoxImg" src={dbaccounting} alt="config" />
                    <h3>REVENUE</h3>
                </div>
                <div className="side-arrow">
                    <img src={sideArrow} alt="arrow" />
                </div>
            </div>
        );
    }
}

function GetLogoHeaderTitle() {
    if (window?.location?.href?.includes("/revenue/")) {
        if (
            window.location.origin.toLowerCase().indexOf("hotelswitchboard.com") >= 0
        ) {
            return "RevEVOLVE";
        } else if (
            window.location.origin.toLowerCase().indexOf("ai.revnomix.com") >= 0
        ) {
            return "RevnomixBI";
        } else if (
            window.location.origin.toLowerCase().indexOf("mhorm.com") >= 0
        ) {
            return "MHOBI";
        } else if (
            window.location.origin.toLowerCase().indexOf("rategain.com") >= 0
        ) {
            return "NavigatorBI";
        } else if (
            window.location.origin.toLowerCase().indexOf("bi.nxtgenrm.com") >= 0
        ) {
            return "NXTGenBI";
        } else {
            return "Revenue";
        }
    } else if (window?.location?.href?.includes("/crm/")) {
        return "CRM";
    } else if (window?.location?.href?.includes("/configuration/")) {
        return "Configuration";
    } else if (window?.location?.href?.includes("/operation/")) {
        return "Operation";
    } else if (window?.location?.href?.includes("/rateshop/")) {
        return "Rateshop";
    } else if (window?.location?.href?.includes("/ratedistribution/")) {
        return "Rate Distribution";
    } else {
        return "Switchboard";
    }
}

function fnGenerateSnapshotHTML(snapshotid) {
    $("#snapshot_html_clone").remove();

    $("#snapshot_" + snapshotid)
        .find("img.chartimg")
        .remove();

    $("#snapshot_" + snapshotid)
        .find("canvas")
        .each(function () {
            $(this)
                .parent()
                .append(
                    "<img class='chartimg' style=display:none; src=" +
                    this.toDataURL() +
                    " />"
                );
        });

    let snapshot = $("#snapshot_" + snapshotid).clone();
    $(snapshot).find("canvas").remove();
    $(snapshot)
        .find("img.chartimg")
        .css("display", "inline-block", "width", "100%");
    $(snapshot).find(".chartWrapper").css("height", "100%");
    $(snapshot).find("select").remove();
    $(snapshot).find("input").remove();
    $(snapshot).find("button").replaceWith("<span></span>");
    $(snapshot).find(".react-datepicker-wrapper").remove();
    $(snapshot).find(".p-multiselect").remove();
    $(snapshot).find(".widget-container-menu").remove();
    $(snapshot).find(".make-comment-in-widget").remove();
    $(snapshot).find("table img:not(.chartimg)").remove();
    $(snapshot).find(".label-radio.form-check-label").remove();
    $(snapshot).find("span").css("display", "block");
    $(snapshot).find(".ViewPropertySetupTable").css("max-width", "calc(100vw - 73px)");
    $("body").append("<div id='snapshot_html_clone'></div>");

    const styleTags = document.querySelectorAll("style");
    styleTags.forEach((styleTag) => {
        $("#snapshot_html_clone").append(styleTag);
    });

    const linkTags = document.querySelectorAll("link");
    linkTags.forEach((linkTag) => {
        if (linkTag.getAttribute("href")) {
            if (linkTag.getAttribute("href").indexOf(".css") >= 0) {
                fetch(linkTag.getAttribute("href"))
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }
                        return response.text();
                    })
                    .then((cssText) => {
                        if (cssText) {
                            cssText = cssText.replace(
                                /url\(["']?data:image\/svg\+xml[^"')]*["']?\)?/gi,
                                "none"
                            );
                            //cssText = cssText.replaceAll("rgba(0, 0, 0, 0.25)", "%2300000040")
                            //cssText = cssText.replaceAll("rgba(255, 255, 255, 0.25)", "%23ffffff40")
                            $("#snapshot_html_clone").append(
                                "<style>" + cssText + "</style>"
                            );
                        }
                    })
                    .catch((error) => { });
            }
        }
    });
    $("#snapshot_html_clone").append(snapshot);
}

function GrowthFormula(curr, stly) {
    const a = Number(curr);
    const b = Number(stly);

    if (!Number.isFinite(a) || !Number.isFinite(b) || a < 0 || b < 0) {
        return 0;
    }

    if (b === 0) {
        if (a === 0) return 0;
        return 0;
    }

    const percent = ((a - b) / b) * 100;
    return Math.round(percent);
}


function GrowthDiifValue(curr, stly) {
    const a = Number(curr);
    const b = Number(stly);

    if (a && b) {
        return Math.round(a - b);
    }

    return 0;
}

function SummationFormula(curr, sotm) {
    if (sotm >= 0 && curr >= 0) {
        return Math.round(Number(curr) - Number(sotm));
    } else {
        return 0;
    }
}

function FindPercentageOfValue(value, percentagebaseon) {
    if (value && percentagebaseon) {
        if (value > 0 && percentagebaseon > 0) {
            return (value * 100) / percentagebaseon;
        }
    }
    return 0;
}

function FindPercentageOfValueMaxUpTo100(value, percentagebaseon) {
    if (value && percentagebaseon) {
        if (value > 0 && percentagebaseon > 0) {
            const result = (value * 100) / percentagebaseon;
            return Math.min(100, result);
        }
    }
    return 0;
}

function ForecastTypeDisplayLable(type) {
    let lable = type
    if (type) {
        if (type.toLowerCase() === "ema") {
            lable = "System Forecast"
        }
        else if (type.toLowerCase() === "rms") {
            lable = "RMS Forecast"
        }
        else if (type.toLowerCase() === "user") {
            lable = "User Forecast"
        }
        else if (type.toLowerCase() === "nova") {
            lable = "RM Copilot Forecast"
        }
        else if (type.toLowerCase() === "otb") {
            lable = "On the Books"
        }
        else if (type.toLowerCase() === "netstly") {
            lable = "Net STLY"
        }
        else if (type.toLowerCase() === "totally") {
            lable = "Total LY"
        }

    }
    return lable;
}


function timeAgo(utcDateString) {

    if (utcDateString) {
        const utcDate = new Date(utcDateString);

        // Current browser local time
        const now = new Date();

        // Difference in seconds
        const diffSeconds = Math.floor((now - utcDate) / 1000);

        if (diffSeconds < 60) {
            return `${diffSeconds}s ago`;
        }

        const diffMinutes = Math.floor(diffSeconds / 60);
        if (diffMinutes < 60) {
            return `${diffMinutes}m ago`;
        }

        const diffHours = Math.floor(diffMinutes / 60);
        if (diffHours < 24) {
            return `${diffHours}h ago`;
        }

        const diffDays = Math.floor(diffHours / 24);

        return `${diffDays}d ago`;
    }
    else {
        return "";
    }
}


function DayDiffOfTowDate(startDate, endDate) {
    if (startDate && endDate) {
        const d1 = new Date(startDate);
        const d2 = new Date(endDate);

        const diffMs = d2 - d1;


        return Math.floor(
            diffMs / (1000 * 60 * 60 * 24)
        );
    }
    else {
        return 0;
    }
}

function generateGlobalClickTrackerID(componentName = "", element = "", uid = "") {
    const formattedUID = uid
        ? moment(uid).isValid()
            ? moment(uid).format("YYYYMMDD")
            : String(uid)
        : "";

    return `${componentName}_${element}_${formattedUID}`
        .replace(/[^a-zA-Z0-9_-]/g, "_")
        .replace(/_+/g, "_")
        .replace(/^_|_$/g, "")
        .toLowerCase();
}

function getCurrentModuleName() {
    let module = "";
    if (window?.location?.href?.includes("/revenue/")) {
        module = "Revenue";
    }
    else if (window?.location?.href?.includes("/rateshop/")) {
        module = "Rateshop";
    }
    else if (window?.location?.href?.includes("/configuration/")) {
        module = "Configuration";
    }
    else if (window?.location?.href?.includes("/crm/")) {
        module = "CRM";
    }

    return module;
}